export default __webpack_public_path__ + "static/media/washupWelcome.44bbebe8.png";